<template>
    <div class="headersearch">
        <div class="h4 headersearch__title underline">Wat zoek je?</div>

        <div class="row">
            <div class="column small-24 medium-10">

                <div class="tabs">
                    <div class="tabs__tab" :class="{'tabs__tab--active': currentType == 'doen'}" @click="setTab('doen')">
                        Ik wil iets doen
                    </div>
                    <div class="tabs__tab" :class="{'tabs__tab--active': currentType == 'leren'}" @click="setTab('leren')">
                        Ik wil iets leren
                    </div>
                    <div class="tabs__tab" :class="{'tabs__tab--active': currentType == 'groep'}" @click="setTab('groep')">
                        Ik zoek een groep of initiatief
                    </div>
                </div>

            </div>

            <div class="column small-24 medium-14">
                <div class="headersearch__content">
                    <ContentDoen v-if="currentType == 'doen'"/>
                    <ContentLeren v-if="currentType == 'leren'"/>
                    <ContentGroep v-if="currentType == 'groep'"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ContentDoen from './ContentDoen.vue';
    import ContentLeren from './ContentLeren.vue';
    import ContentGroep from './ContentGroep.vue';

    export default {
        components: {
            ContentDoen,
            ContentLeren,
            ContentGroep
        },
        data() {
            return {
                currentType: 'doen',
                searchedLocation: ''
            }
        },
        mounted() {

        },
        methods: {
            setTab(type) {
                this.currentType = type;
            }
        }
    }
</script>
